import { useNavigate } from 'react-router-dom';
import { useLocales } from "../../locales";

// routes
import { PATH_AUTH } from '../../routes/paths';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from 'src/components/snackbar'

export const HandleLogout = async () => {
    const { translate } = useLocales();

    const { logout } = useAuthContext();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    try {
        logout();
        navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
        console.error(error);
        enqueueSnackbar(translate('Unable to logout!'), { variant: 'error' });
    }
};